<template>

    <FlashNotifications ref="flash" />
    <section>
        <div class="px-5 mt-5 mb-10" >
                        
            <div class="md:flex ">
                <div class="w-full">
                    <div class="mb-5 flex flex-col md:flex-row justify-between items-center">
                        <div class="relative flex items-center">
                                <select @change="fetchUsersList" v-model="page.limit" class="appearance-none h-full rounded-lg border text-sm block appearance-none w-full bg-white border-gray-300 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 dark:bg-[#1C2128] dark:border-gray-500 dark:text-gray-400">
                                    <option v-for="num in [10,20,50,100,500]" :value="num">
                                        {{ num }}
                                    </option>
                                </select>
                                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 dark:text-gray-400"></div>
                                <p class="whitespace-nowrap ml-2 text-gray-700 text-sm dark:text-gray-400">(Total Users: {{ page.total_records }} )</p>
                        </div>
                        

                        <div class="flex flex-col md:flex-row items-center w-full md:w-fit gap-3 mx-1 mt-4 md:mt-0">
                            <div class="order-3 md:order-1 flex items-center gap-3 w-full md:w-fit">
                                <select v-model="sort_by" name="sortBy" class="text-gray-500 hover:text-gray-700 hover:bg-gray-50 w-3/5 md:w-36 items-center px-3 border border-gray-300 rounded-lg text-sm dark:hover:bg-gray-700 dark:bg-[#1C2128] dark:border-gray-500 dark:text-gray-400">
                                    <option value="created_at">Created at</option>
                                    <option value="responded_at">Responded at</option>
                                    <option value="status">Status</option>
                                    <option value="invited_by_admin_id">Invited by admin</option>
                                </select>
                                <select v-model="sort_order" name="sortOrder" class="text-gray-500 hover:text-gray-700 hover:bg-gray-50 w-2/5 md:w-20 items-center px-3 border border-gray-300 rounded-lg text-sm dark:hover:bg-gray-700 dark:bg-[#1C2128] dark:border-gray-500 dark:text-gray-400">
                                    <option value="ASC" >Asc</option>
                                    <option value="DESC">Dsc</option>
                                </select>
                            </div>
                            <div class="relative order-2 w-full md:w-fit">
                                    <span class="h-full absolute inset-y-0 left-0 flex items-center pl-2">
                                        <button>
                                            <svg viewBox="0 0 24 24" class="h-4 w-4 fill-current text-gray-500">
                                                <path
                                                        d="M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z">
                                                </path>
                                            </svg>
                                        </button>
                                    </span>
                                <input :placeholder="I18N.application.attendees.search_placeholder"
                                       v-model="search"
                                       @input="fetchUsersList"
                                       class="w-full md:w-[180px] lg:w-80 appearance-none rounded border border-gray-300 border-b focus:border-0 transition focus:ring-2 focus:ring-blue-600 block pl-8 pr-6 py-2 w-full bg-white text-sm placeholder-gray-400 text-gray-700 focus:bg-white focus:outline-none dark:bg-[#1C2128] dark:border-gray-500 dark:focus:ring-gray-400 dark:text-gray-400"/>
                            </div>
                            <button @click="toggleModal" class="order-1 md:order-3 px-3 py-2 w-full md:w-fit text-sm text-white bg-blue-600 rounded">Send Invite</button>
                        </div>
                    </div>
                    <div class="w-full sm:shadow-lg shadow-gray-300 sm:rounded-lg overflow-x-auto">
                        <table class="min-w-full leading-normal">
                            <thead class="bg-blue-600 text-white">
                                <tr>
                                    <th class="text-nowrap px-6 md:pr-3 md:pl-7 py-4 text-left text-xs font-semibold uppercase tracking-wider">
                                                <span class="flex">
                                                    {{ I18N.application.attendees.user }}
                                                </span>
                                    </th>
<!--                                    <th class="text-nowrap hidden sm:table-cell  py-4 text-left text-xs font-semibold uppercase tracking-wider">-->
<!--                                                <span class="flex">-->
<!--                                                    Location-->
<!--                                                </span>-->
<!--                                    </th>-->
                                    <th class="text-nowrap hidden sm:table-cell  py-4 text-left text-xs font-semibold uppercase tracking-wider">
                                                <span class="flex">
                                                    Invited By
                                                </span>
                                    </th>

                                    
                                    <th class="text-nowrap hidden sm:table-cell  py-4 text-left text-xs font-semibold uppercase tracking-wider">
                                                <span class="flex">
                                                    Details
                                                </span>
                                    </th>
<!--                                    <th class="text-nowrap hidden sm:table-cell  py-4 text-left text-xs font-semibold uppercase tracking-wider">-->
<!--                                                <span class="flex">-->
<!--                                                    Status-->
<!--                                                </span>-->
<!--                                    </th>-->
                                    <th class="px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider">
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="dark:bg-[#1C2128]">
                                <tr v-for="user in users" :key="user.id">
                                    <td class="text-nowrap px-5 py-4 border-b border-gray-200 dark:border-gray-500 text-sm">
                                        <div class="flex items-center">
                                            <div class="flex-shrink-0 w-12 h-12">
                                                <div v-if="user.joined_user != null">
                                                    <img class="w-full h-full rounded-full"
                                                         :src="user.joined_user.profile_picture_url"
                                                         alt=""
                                                         v-if="user.joined_user.profile_picture_url !== '' && user.joined_user.profile_picture_url !== null"/>
                                                    <p v-else class="text-gray-600 bg-[#cccccc] w-12 h-12 flex justify-center items-center border border-[3px] border-[#b2b2b2] hover:border-gray-500 rounded-full">
                                                    {{ user.joined_user.avatar_name }}
                                                </p>
                                                </div>
                                                <p v-else class="text-gray-600 bg-[#cccccc] w-12 h-12 flex justify-center items-center border border-[3px] border-[#b2b2b2] hover:border-gray-500 rounded-full">
                                                    {{ user.avatar_name }}
                                                </p>
                                            </div>
                                            <div class="ml-3">
                                                <p class="text-gray-900 dark:text-gray-400 whitespace-no-wrap">
                                                    <span class="flex items-center">
                                                        <span>{{ user.name }}</span>
                                                    </span>
                                                    <span class="text-xs text-gray-600 dark:text-gray-400">{{ user.email }}</span>
                                                    <span :class="{'text-blue-400 border-blue-400' : user.status == 'pending', 'text-green-400 border-green-400' : user.status == 'joined', 'text-red-400 border-red-400' : user.status == 'declined'}" class="text-[10px] border-[0.5px] rounded px-0.5 py-0.5 dark:text-gray-300">{{ user.status.charAt(0).toUpperCase() + user.status.slice(1) }}</span>
                                                    
                                                </p>
                                            </div>
                                        </div>
                                    </td>
<!--                                    <td class="text-nowrap hidden sm:table-cell  py-4 border-b border-gray-200 dark:border-gray-500 dark:text-gray-400 text-sm">-->
<!--                                        <p class="text-gray-900 dark:text-gray-400 whitespace-no-wrap">{{ user.signup_location }}</p>-->
<!--                                        <p> {{ user.created_at_for_ui }}</p>-->
<!--                                    </td>-->
                                    <td class="text-nowrap hidden sm:table-cell  py-4 border-b border-gray-200 dark:border-gray-500 dark:text-gray-400 text-sm">
                                        <div class="flex items-center">
                                            <div class="flex-shrink-0 w-12 h-12">
                                                <img class="w-full h-full rounded-full"
                                                     :src="user.host.profile_picture_url"
                                                     alt=""
                                                     v-if="user.host.profile_picture_url !== '' && user.host.profile_picture_url !== null"/>
        
                                                <p v-else class="text-gray-600 bg-[#cccccc] w-12 h-12 flex justify-center items-center border border-[3px] border-[#b2b2b2] hover:border-gray-500 rounded-full">
                                                    {{ user.host.avatar_name }}
                                                </p>
                                            </div>
                                            <div class="ml-3">
                                                <p class="text-gray-900 dark:text-gray-400 whitespace-no-wrap">
                                                    <span class="flex items-center">
                                                        <span>{{ user.host.full_name }}</span>
                                                    </span>
                                                    <span class="text-xs text-gray-600 dark:text-gray-400">{{ user.host.email }}</span>
                                                </p>
                                            </div>
                                        </div>
                                        
                                    </td>

                                    <td class="text-nowrap hidden sm:table-cell w-fit py-4 border-b border-gray-200 dark:border-gray-500 text-sm">
                                        <p v-if="user.responded_at" class="text-sm text-gray-900 dark:text-gray-400 whitespace-no-wrap">
                                            Responded at: {{ user.responded_at }}
                                        </p>
                                        <p class="text-sm text-gray-900 dark:text-gray-400 whitespace-no-wrap">
                                            Email opened: {{ user.is_email_opened }}
                                        </p>
                                    </td>
<!--                                    <td class="text-nowrap hidden sm:table-cell w-fit py-4 border-b border-gray-200 dark:border-gray-500 text-sm">-->
<!--                                        <span :class="{'text-blue-400 border-blue-400' : user.status == 'pending', 'text-green-400 border-green-400' : user.status == 'joined', 'text-red-400 border-red-400' : user.status == 'cancel'}" class="text-[11px] border-[0.5px] min-w-[] rounded px-0.5 py-0.5 dark:text-gray-300">{{ user.status.charAt(0).toUpperCase() + user.status.slice(1) }}</span>-->
<!--&lt;!&ndash;                                        <p class="text-sm text-gray-900 dark:text-gray-400 whitespace-no-wrap">&ndash;&gt;-->
<!--&lt;!&ndash;                                            {{ user.status }}&ndash;&gt;-->
<!--&lt;!&ndash;                                        </p>&ndash;&gt;-->
<!--                                    </td>-->
                                    <td class="pl-5 py-4 border-b border-gray-200 dark:border-gray-500 dark:text-gray-300 text-sm">
                                        <div class="flex items-center">
                                            <div class="">
                                                <button v-if="user.status != 'joined'" @click="reInviteUser(user.id)" class="text-sm hover:underline font-semibold">
                                                    Re-invite
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
    
                    <div class="mt-5 px-3 sm:px-0 text-center flex items-center justify-between w-full">
                        <p class="text-sm text-gray-700/90 dark:text-gray-400 justify-self-start">
                            {{ I18N.application.attendees.page }} {{ page.current_page }} {{ I18N.application.attendees.of }} {{ page.total_pages }}
                        </p>
                        <button @click="prevPage" :disabled="page.current_page === 1"
                                class="ml-auto  text-sm bg-gray-300/80 shadow-sm hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded-l-lg">
                            {{ I18N.application.attendees.prev }}
                        </button>
    
                        <button @click="nextPage" :disabled="page.current_page === page.total_pages"
                                class=" text-sm bg-blue-600 shadow-sm hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-r-lg">
                            {{ I18N.application.attendees.next }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div v-show="showModal" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] md:h-full justify-center items-center flex">
        <div class="relative w-full h-full max-w-md md:h-auto">
          <div class="relative bg-white border border-gray-200 rounded shadow-lg shadow-gray-500 dark:shadow-gray-700 dark:bg-[#22272E] dark:border-gray-500">
            <div class="px-6 py-3 lg:px-8">
              <h3 class="my-2 text-xl text-gray-900 dark:text-gray-400">Send Invitation</h3>
              <p class="text-gray-500 text-sm mb-3">Enter name and email of a user that you want to invite to TimelyDo. User will receive an email shortly with your invitation.</p>
              <form @submit.prevent="sendInvitation">
                <div class="mb-6 space-y-2">
                    <TimelydoInput :value="user_invitation.name" 
                                    @input="updateUserInvitationData" 
                                    placeholder="Name" 
                                    inputClasses="w-full"
                                    name="user_invitation[name]" 
                                    :opts="{id: 'user_name', required: true }">              
                    </TimelydoInput>
                    <TimelydoInput :value="user_invitation.email" 
                                    @input="updateUserInvitationData" 
                                    placeholder="Email" 
                                    inputClasses="w-full"
                                    name="user_invitation[email]" 
                                    :opts="{id: 'user_email', required: true }">              
                    </TimelydoInput>
                </div>
                <div class="md:flex w-full items-center justify-end rounded-b dark:border-gray-500">
                  <button type="submit" class="text-white bg-blue-600 hover:bg-blue-800 font-medium rounded-[5px] text-sm px-3 py-1.5 text-center w-full md:w-fit ml-0 md:ml-3 mb-3 md:mb-0">
                    Send
                  </button>
                  <button @click="toggleModal" type="button" class="text-gray-600 bg-white hover:bg-gray-100 rounded-[5px] border border-gray-400 text-sm font-medium px-3 py-[5px] hover:text-gray-900 focus:z-10 w-full md:w-fit md:order-first dark:border-gray-400 dark:bg-[#22272E] dark:text-gray-400 dark:hover:bg-gray-500">{{ I18N.application.bookings.upcoming.cancel }}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
    </div>
    <div v-show="showModal" class="bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40"></div>

      
</template>

<script>
import RequestMixin from "controllers/vue_components/mixins/request"
import Constants from "controllers/vue_components/mixins/constants"
import Formatting from "controllers/vue_components/mixins/formatting"
import FlashNotifications from "controllers/vue_components/flash_toast"
import TimelydoInput from "controllers/vue_components/fields/timelydo_input";

export default {
    name: 'UserInvitations',
    components: {
        FlashNotifications, TimelydoInput
    },
    mixins: [RequestMixin, Constants, Formatting],
    data() {
        return {
            showModal: false,
            user_invitation: {
              name: '',
              email: ''
            },
            page: {
                limit: 10,
                number: 1
            },
            users: [],
            sort_order: 'DESC',
            sort_by: 'created_at',
            search: '',
        };
    },
    methods: {
        toggleModal() {
            this.showModal = !this.showModal
            if(!this.showModal){
                this.user_invitation = {
                    name: '',
                    email: ''
                }
            }
        },
        updateUserInvitationData(e){
            let [objectName, fieldName] = e.target.name.split('[').map(part => part.replace(']', ''));

            this.user_invitation[fieldName] = e.target.value
        },
        async sendInvitation(){
            let response = await this.axiosRequest('POST', '/api/v1/admin/user_invitations', {user_invitation : this.user_invitation }, false)
            if (response.js_error == false && response.response.success) {
                this.toggleModal();
                this.$refs.flash.show(response.response.message, 'notice');
                this.fetchUsersList();
            }
            else {
                this.$refs.flash.show(response.error.data.message, 'alert');
            }
        },
        async reInviteUser(id){
            let response = await this.axiosRequest('POST', `/api/v1/admin/user_invitations/${id}/re_invite`, {}, false)
            if (response.js_error == false && response.response.success) {
                this.$refs.flash.show(response.response.message, 'notice');
            }
            else {
                this.$refs.flash.show(response.error.data.message, 'alert');
            }
        },
        async fetchUsersList() {
            let response = await this.axiosRequest('POST', '/api/v1/admin/user_invitations/list',  this.filters_data, false)
            if (response.js_error == false && response.response.success) {
                this.users = response.response.data.records
                this.page = response.response.data.page
            }
        },

        async nextPage() {
            if (this.page.current_page < this.page.total_pages) {
                this.page.number++;
                this.fetchUsersList();
            }

        },
        async prevPage() {
            if (this.page.current_page > 1) {
                this.page.number--;
                this.fetchUsersList();
            }
        },

    },

    computed: {
        filters_data() {
            let main_filters = {};
            main_filters['sort_by'] = this.sort_by;
            main_filters['sort_order'] = this.sort_order;
            main_filters['page'] = {
                limit: this.page.limit,
                number: this.page.number,
            }
            main_filters['filters'] = {}
            if (this.search != '') {
                main_filters['search'] = this.search;
            }
            return main_filters;
        },

    },
    created() {
        this.fetchUsersList();
    },

    mounted() {

    },
    watch: {
        'sort_by'(newValue) {
            this.fetchUsersList();
        },

        'sort_order'(newValue) {
            this.fetchUsersList();
        },

        'this.page.current_page'(newValue) {
            this.fetchUsersList();
        },
    }
};
</script>
